import facebook from "./facebook.png"
import youtube from "./youtube.png"
import instagram from "./instagram.png"

const icons = {
    facebook, youtube, instagram
}
export default icons